import { render, staticRenderFns } from "./SettingsDrawer.vue?vue&type=template&id=3e23a5b5"
import script from "./SettingsDrawer.vue?vue&type=script&lang=js"
export * from "./SettingsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports